"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasConnectedAccounts = void 0;
const re_reselect_1 = require("re-reselect");
const accounts_1 = require("companion-app-components/flux/accounts");
const selectors_1 = require("data/institutionLogins/selectors");
exports.hasConnectedAccounts = (0, re_reselect_1.createCachedSelector)((state, props) => (0, selectors_1.getInstitutionLoginForId)(state, props.institutionLoginId), accounts_1.accountsSelectors.getAccountsForInstitutionLoginId, (institutionLogin, accounts) => {
    var _a;
    if (!institutionLogin) {
        return false;
    }
    if ((_a = institutionLogin.aggregators) === null || _a === void 0 ? void 0 : _a.get(0).cpId) {
        return true;
    }
    const found = accounts.find((account) => { var _a, _b; return Boolean((_b = (_a = account.aggregators) === null || _a === void 0 ? void 0 : _a.get(0)) === null || _b === void 0 ? void 0 : _b.cpId); });
    return !!found;
})({
    keySelector: (state, props) => props.institutionLoginId || '0',
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 25 }),
});
